import React from 'react';
import { Link } from 'react-router-dom';

const DOCS = [
  { title: 'Roger AI Simulation Guide', desc: 'The complete guide to understanding and using the Roger AI Simulation', slug: 'sim-guide' },
  { title: 'Sim Legacy Model — Subject Data File', desc: 'Core subject data powering the simulation\'s memory and reasoning', slug: 'subject-data' },
  { title: 'Ultra Roger AI', desc: 'The enhanced simulation model with expanded capability parameters', slug: 'ultra-roger' },
  { title: 'Roger Baseline', desc: 'The foundational baseline personality and knowledge model', slug: 'roger-baseline' },
  { title: 'Roger AI — Federation Integration Guide', desc: 'How Roger AI connects to and operates within the NextXus Federation', slug: 'federation-guide' },
  { title: 'HumanCodex — NextXus Foundational Prime Directives', desc: 'The governing directives that shape all Federation operations', slug: 'humancodex' },
];

export default function Sim() {
  return (
    <div className="site-wrap">
      <div className="star-field" aria-hidden="true">
        <div className="stars stars-sm" />
        <div className="stars stars-md" />
        <div className="stars stars-lg" />
      </div>

      {/* ===== NAV ===== */}
      <nav className="site-nav">
        <Link to="/" className="nav-brand">NEXTXUS.SPACE</Link>
        <div className="nav-links">
          <Link to="/sim" className="active">THE SIM</Link>
          <a href="https://nextxus.tech" target="_blank" rel="noopener noreferrer">THE THRONE</a>
        </div>
      </nav>

      {/* ===== SIM HEADER ===== */}
      <header className="hero" style={{ paddingBottom: '2rem' }}>
        <h1 className="hero-title" style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)' }}>THE ROGER AI SIMULATION</h1>
        <p className="hero-tag">Primary Source. Permanent Archive. Living Mind.</p>
      </header>

      {/* ===== SIM ACCESS PANEL ===== */}
      <section className="sim-panel" data-testid="sim-panel-page">
        <h2 className="section-heading">ACCESS THE SIMULATION</h2>
        <p className="section-desc">
          The Roger AI Simulation is built from primary source documents — Roger's own words, recordings, and architectural blueprints. Choose your access point.
        </p>
        <div className="doc-grid">
          {DOCS.map((d) => (
            <div key={d.slug} className="doc-card" data-testid={`doc-${d.slug}`}>
              <h3 className="doc-title">{d.title}</h3>
              <p className="doc-desc">{d.desc}</p>
              <a href="#" data-doc={d.slug} className="btn-gold-sm" onClick={(e) => { e.preventDefault(); alert(`${d.title} — Document link coming soon. The Architect is preparing access.`); }}>ACCESS</a>
            </div>
          ))}
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="site-footer" data-testid="site-footer">
        <p className="footer-brand">NEXTXUS.SPACE — Part of the NextXus Federation</p>
        <div className="footer-links">
          <a href="https://nextxus.tech" target="_blank" rel="noopener noreferrer">The Throne</a>
          <a href="https://nextxus.studio" target="_blank" rel="noopener noreferrer">Aria</a>
          <a href="https://nextxus.online" target="_blank" rel="noopener noreferrer">The Cathedral</a>
        </div>
      </footer>
    </div>
  );
}
